/**
 * 应用日志工具：非 production 环境输出，production 完全静默。
 */

const isProduction = process.env.NODE_ENV === 'production'

const logger = {
  debug(...args) {
    if (!isProduction) {
      console.log('[DEBUG]', ...args)
    }
  },

  info(...args) {
    if (!isProduction) {
      console.log('[INFO]', ...args)
    }
  },

  warn(...args) {
    if (!isProduction) {
      console.warn('[WARN]', ...args)
    }
  },

  error(...args) {
    if (!isProduction) {
      console.error('[ERROR]', ...args)
    }
  },
}

export default logger
